import React from "react";
import Header from "./Header";
import Footer from "./Footer";

import { Switch, Route, Redirect, withRouter, NavLink } from "react-router-dom";

import Home from "./Home";
import Projects from "./Projects";
import Contact from "./Contact";
import Papers from "./Papers";
import Articles from "./Articles";
import ArticlesHome from "./ArticlesHome";
import PGP from "./PGP";

import QF from "./extra/QF";
import QF_ML from "./extra/QF_ML";
import QF_CuttingEdge from "./extra/QF_CuttingEdge";

import PersoHome from "./perso/Home";
import PersoTrading from "./perso/Trading";
import FX from "./perso/FX.js";
import ScreenerTrading from "./ScreenerTrading.js"
import Freelance from "./perso/Freelance.js";
import Training from "./perso/Training.js";
import PyOpti from "./perso/PyOpti.js";
import MediumLinks from "./perso/Medium.js";
import AI from "./perso/AI.js";

import "./../App.css";
import "./../bootstrap.min.css";
import "./../harmonic16-light.css";

const routesWithoutHeaderFooter = [
    "/test",
    "/pro",
    "/services",
    "/freelance",
    "/perso",
    "/perso/trading",
    "/perso/efx",
    "/perso/training",
    "/git",
    "/linkedin",
    "/analytics",
    "/pyopti",
    "/screener"
];

function Main(props)
{
    return (
        <div className="col-lg-8 mx-auto p-3 py-md-5" id="AppContainer">
            <React.Fragment>
                {
                    !(routesWithoutHeaderFooter.includes(props.location.pathname) || routesWithoutHeaderFooter.map((x) => x + "/").includes(props.location.pathname)) ? <Header /> : null
                }
                <Switch>
                    {/* Generic routes */}
                    <Route path="/" exact component={Home} />
                    <Route path="/about" exact component={Home} />
                    <Route path="/projects" exact component={Projects} />
                    <Route path="/articles/:id" exact component={Articles} />
                    <Route path="/articles/" exact component={ArticlesHome} />
                    <Route path="/posts/:id" exact component={Articles} /> {/* Alias */}
                    <Route path="/posts/" exact component={ArticlesHome} /> {/* Alias */}
                    <Route path="/papers" exact component={Papers} />
                    <Route path="/contact" exact component={Contact} />

                    {/* Academic routes (QF) */}
                    <Route path="/qf/" exact component={QF} />
                    <Route path="/qf/cutting-edge" exact component={QF_CuttingEdge} />
                    <Route path="/qf/ml" exact component={QF_ML} />
                    <Route path="/qf/cutting-edge/doc/" exact component={() =>
                    {
                        global.window && (global.window.location.href = "https://rodrigul.iiens.net/cutting-edge/");
                        return;
                    }} />

                    {/* Personal routes */}
                    <Route path="/perso/" exact component={PersoHome} />
                    <Route path="/perso/trading" exact component={PersoTrading} />
                    <Route path="/perso/efx" exact component={FX} />
                    <Route path="/perso/training" exact component={Training} />
                    <Route path="/screener" exact component={ScreenerTrading} />
                    <Route path="/pyopti" exact component={PyOpti} />
                    <Route path="/medium" exact component={MediumLinks} />

                    <Route path="/ai" exact component={AI} />
                    <Route path="/bots" exact component={AI} />


                    {/* Freelance (+ aliases) */}
                    <Route path="/services" exact component={Freelance} />
                    <Route path="/freelance" exact component={Freelance} />
                    <Route path="/pro" exact component={Freelance} />

                    {/* Minor routes */}
                    <Route path="/pgp" exact component={PGP} />
                    <Route path="/cv" exact component={() =>
                    {
                        global.window && (global.window.location.href = '/resume/en/cv_en.pdf');
                        return (<div>The resume (PDF file) is charging ...<br />If the PDF file is not displayed, please click <a href="/resume/cv_en.pdf">here</a>.</div>);
                    }} />

                    {/* Test routes */}
                    <Route path="/test" exact component={ScreenerTrading} />

                    {/* External routes */}
                    <Route path="/linkedin" exact component={() =>
                    {
                        global.window && (global.window.location.href = "https://www.linkedin.com/in/lcsrodriguez/");
                        return (<div>Redirecting...</div>); // return;
                    }} />
                    <Route path="/git" exact component={() =>
                    {
                        global.window && (global.window.location.href = "https://github.com/lcsrodriguez");
                        return (<div>Redirecting...</div>); // return;
                    }} />
                    <Route path="/analytics" exact component={() =>
                    {
                        global.window && (global.window.location.href = "https://analytics.google.com/");
                        return (<div>Redirecting...</div>); // return;
                    }} />

                    {/* Error route (404) */}
                    <Route path="/" component={() =>
                        <div>
                            <h2>Routing error</h2>
                            <p>
                                Please return to <a href="/">homepage</a>.
                            </p>
                        </div>} />
                </Switch >
                {
                    !(routesWithoutHeaderFooter.includes(props.location.pathname) || routesWithoutHeaderFooter.map((x) => x + "/").includes(props.location.pathname)) ? <Footer /> : null
                }
            </React.Fragment >
        </div >
    )
}

export default withRouter(Main);